/* Selma variant picker — Olivia-style UI layered over Dawn's variant machinery.
   Reads window.SELMA_PICKER_CONFIG; transforms option fieldsets and injects
   personalisation fields (text / letter grid / birthstone drawer). */
(function () {
  'use strict';
  function imgUrl(u, w) {
    if (!u) return '';
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  var CFG = window.SELMA_PICKER_CONFIG;
  if (!CFG) return;

  function init() {
    var picker = document.querySelector('variant-selects, variant-radios');
    var productSection = document.querySelector('section[id^="MainProduct-"], .product');
    var handle = (window.location.pathname.match(/\/products\/([a-z0-9-]+)/) || [])[1];
    if (!handle) return;
    var conf = CFG.products[handle];
    if (!conf) return;
    var form = null;
    if (picker) {
      var container = picker.closest('.product__info-container, .product__info-wrapper, section');
      if (container) form = container.querySelector('form[data-type="add-to-cart-form"]');
    }
    if (!form) {
      form = [].slice.call(document.querySelectorAll('form[data-type="add-to-cart-form"]')).filter(function (f) {
        return (f.getAttribute('id') || '').indexOf('product-form-template') === 0 || f.closest('.product__info-container');
      })[0] || document.querySelector('form[data-type="add-to-cart-form"]');
    }
    if (!form) return;

    // ---------- option UI transforms (re-applied after Dawn re-renders) ----------
    var lastPicked = {}; // optName -> value the user chose via drawer
    function applyTransforms() {
      var fieldsets = document.querySelectorAll('variant-selects fieldset, variant-radios fieldset, .product-form__input--pill, .product-form__input--dropdown, .product-form__input');
      var seenNames = {};
      fieldsets.forEach(function (fs) {
        if (fs.dataset.selmaDone) return;
        var legend = fs.querySelector('legend, .form__label');
        if (!legend) return;
        var optName = legend.textContent.replace(/:$/, '').trim().replace(/\s+/g, ' ');
        Object.keys(conf.o).forEach(function (k) {
          if (optName.toLowerCase().indexOf(k.toLowerCase()) === 0) optName = k;
        });
        var oc = conf.o[optName];
        if (!oc || seenNames[optName]) return;
        seenNames[optName] = true;
        fs.dataset.selmaDone = 'true';
        if (oc.ui === 'swatch') transformSwatch(fs, oc);
        else if (oc.ui === 'charm') transformCharm(fs, oc, optName);
        else if (oc.ui === 'count') transformCount(fs, conf, optName);
        else if (oc.ui === 'dropdown') fs.classList.add('selma-dd');
        else if (oc.ui === 'select') transformSelect(fs, oc, optName);
      });
    }
    applyTransforms();
    var reapplyTimer = null;
    var mo = new MutationObserver(function () {
      clearTimeout(reapplyTimer);
      reapplyTimer = setTimeout(applyTransforms, 120);
    });
    var pickerRoot = document.querySelector('variant-selects, variant-radios');
    if (pickerRoot && pickerRoot.parentElement) {
      mo.observe(pickerRoot.parentElement, { childList: true, subtree: true });
    }

    // ---------- personalisation fields ----------
    if (conf.f && conf.f.length) {
      var host = document.createElement('div');
      host.className = 'selma-fields';
      var anchor = document.querySelector('variant-selects, variant-radios');
      if (anchor) anchor.insertAdjacentElement('afterend', host);
      else form.parentElement.insertBefore(host, form);
      conf.f.forEach(function (f, idx) { host.appendChild(buildField(f, idx, form)); });
      wireCounts(conf, host);
      form.addEventListener('submit', function (e) { if (!validate(host)) { e.preventDefault(); e.stopImmediatePropagation(); } }, true);
    }

    // ---------- builders ----------
    function transformSwatch(fs, oc) {
      fs.classList.add('selma-swatch-option');
      fs.querySelectorAll('input[type="radio"]').forEach(function (input) {
        var label = fs.querySelector('label[for="' + CSS.escape(input.id) + '"]');
        if (!label) return;
        var val = input.value;
        var color = oc.colors[val] || '#ccc';
        label.classList.add('selma-swatch');
        label.style.setProperty('--selma-swatch-color', color);
        label.setAttribute('data-selma-title', val);
        label.title = val;
        var sync = function () { label.classList.toggle('is-checked', input.checked); };
        sync();
        fs.addEventListener('change', function () { setTimeout(sync, 30); });
      });
    }

    function transformCharm(fs, oc, optName) {
      fs.classList.add('selma-charm-option');
      var values = fs.querySelector('.product-form__input, fieldset') || fs;
      var radios = [].slice.call(fs.querySelectorAll('input[type="radio"]'));
      if (!radios.length) return;
      // hide native radios/labels
      radios.forEach(function (r) {
        r.classList.add('selma-sr-only');
        var l = fs.querySelector('label[for="' + CSS.escape(r.id) + '"]');
        if (l) l.classList.add('selma-hidden');
      });
      var set = CFG.sets[oc.set] || [];
      var pill = makePill('Add a birthstone');
      fs.appendChild(pill.wrap);
      var checked = radios.filter(function (r) { return r.checked; })[0];
      var opened = false;
      // Only show as selected if the user picks; default first variant stays "Add a birthstone" like Olivia
      pill.btn.addEventListener('click', function () {
        openDrawer('Select Birthstone', radios.map(function (r, i) {
          return { label: r.value, img: set[stoneIndex(r.value)] };
        }), function (i) {
          radios[i].checked = true;
          radios[i].dispatchEvent(new Event('change', { bubbles: true }));
          lastPicked[optName] = radios[i].value;
          setPill(pill, radios[i].value, set[stoneIndex(radios[i].value)]);
        });
      });
      if (lastPicked[optName]) {
        setPill(pill, lastPicked[optName], set[stoneIndex(lastPicked[optName])]);
      }
    }

    function transformCount(fs, conf, optName) {
      // Olivia behavior: for "Number of Letters" products with a name field, hide the
      // picker and select the variant from the typed character count instead.
      var hasTextField = (conf.f || []).some(function (f) { return f.k === 'text'; });
      if (/letter/i.test(optName || '') && hasTextField) {
        fs.setAttribute('data-selma-autoletters', '');
        fs.style.display = 'none';
        wireAutoLetters();
        return;
      }
      fs.classList.add('selma-count-option');
    }

    function autoLetters() {
      if (!autoLetters.state) autoLetters.state = { data: null, loading: false, lastCommitted: null };
      return autoLetters.state;
    }

    function letterRadios() {
      var fs = document.querySelector('[data-selma-autoletters]');
      return fs ? [].slice.call(fs.querySelectorAll('input[type="radio"]')) : [];
    }

    function letterTarget(value) {
      var radios = letterRadios();
      if (!radios.length) return null;
      var nums = radios.map(function (r) { return parseInt(r.value, 10); }).filter(function (n) { return !isNaN(n); });
      var n = (value || '').length;
      if (n < Math.min.apply(null, nums)) n = Math.min.apply(null, nums);
      if (n > Math.max.apply(null, nums)) n = Math.max.apply(null, nums);
      var target = null;
      radios.forEach(function (r) { if (parseInt(r.value, 10) === n) target = r; });
      return target;
    }

    function formatMoney(cents) {
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }

    function updateLetterCounter(input) {
      if (!input || input.maxLength < 1) return;
      var wrap = input.closest('.selma-field');
      if (!wrap) return;
      var counter = wrap.querySelector('.selma-char-counter');
      if (!counter) {
        counter = document.createElement('span');
        counter.className = 'selma-char-counter';
        input.insertAdjacentElement('afterend', counter);
      }
      counter.textContent = input.value.length + '/' + input.maxLength;
    }

    // While typing: update the checked radio, the form's variant id and the shown
    // price WITHOUT dispatching a change event (Dawn's section re-render would
    // steal focus from the input on every keystroke).
    function applyLetterCount(value) {
      var target = letterTarget(value);
      if (!target) return;
      if (!target.checked) target.checked = true;
      var d = autoLetters().data;
      if (!d) return;
      var v = null;
      d.variants.forEach(function (x) { if (String(x.option1) === String(target.value)) v = x; });
      if (!v) return;
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = v.id;
      var scope = document.querySelector('.product__info-container') || document;
      var priceEl = scope.querySelector('.price__sale .price-item--sale') || scope.querySelector('.price__regular .price-item--regular');
      if (priceEl) priceEl.textContent = formatMoney(v.price);
    }

    // When the customer leaves the field: one real variant change so URL, sticky
    // bar and everything else sync up (single re-render, focus already gone).
    function commitLetterCount(value) {
      var target = letterTarget(value);
      if (!target) return;
      target.checked = true;
      if (autoLetters().lastCommitted !== target.value) {
        autoLetters().lastCommitted = target.value;
        target.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function wireAutoLetters() {
      if (!autoLetters().data && !autoLetters().loading) {
        autoLetters().loading = true;
        fetch('/products/' + handle + '.js')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            autoLetters().data = d;
            var input = document.querySelector('.selma-fields .selma-input');
            if (input) applyLetterCount(input.value);
          })
          .catch(function () {});
      }
      if (!wireAutoLetters.attached) {
        wireAutoLetters.attached = true;
        document.addEventListener('input', function (e) {
          var t = e.target;
          if (t && t.classList && t.classList.contains('selma-input') && t.closest('.selma-fields')) {
            applyLetterCount(t.value);
            updateLetterCounter(t);
          }
        });
        document.addEventListener('focusout', function (e) {
          var t = e.target;
          if (t && t.classList && t.classList.contains('selma-input') && t.closest('.selma-fields')) {
            commitLetterCount(t.value);
          }
        });
      }
      var tries = 0;
      (function attach() {
        var input = document.querySelector('.selma-fields .selma-input');
        if (input) {
          var nums = letterRadios().map(function (r) { return parseInt(r.value, 10); }).filter(function (n) { return !isNaN(n); });
          if (nums.length) input.maxLength = Math.max.apply(null, nums);
          applyLetterCount(input.value);
          updateLetterCounter(input);
        } else if (++tries < 30) {
          setTimeout(attach, 100);
        }
      })();
    }

    function makePill(placeholder) {
      var wrap = document.createElement('div');
      wrap.className = 'selma-charm-selector';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'selma-charm-pill';
      btn.innerHTML = '<span class="selma-charm-pill-text">' + placeholder + '</span>';
      wrap.appendChild(btn);
      return { wrap: wrap, btn: btn };
    }

    function setPill(pill, label, img) {
      pill.btn.classList.add('selma-charm-pill--selected');
      pill.btn.innerHTML = (img ? '<img class="selma-charm-pill-img" src="' + imgUrl(img, 80) + '" alt="" width="28" height="28">' : '') +
        '<span class="selma-charm-pill-text">' + label + '</span>';
    }

    function stoneIndex(value) {
      var v = value.toLowerCase().slice(0, 3);
      var months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
      var i = months.indexOf(v);
      return i === -1 ? 0 : i;
    }

    // ---------- Etsy-style native dropdown ----------
    function fetchProductJson(cb) {
      var st = fetchProductJson.state || (fetchProductJson.state = { data: null, loading: false, cbs: [] });
      if (st.data) { cb(st.data); return; }
      st.cbs.push(cb);
      if (st.loading) return;
      st.loading = true;
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          st.data = d;
          st.cbs.forEach(function (fn) { fn(d); });
          st.cbs = [];
        })
        .catch(function () {});
    }

    function transformSelect(fs, oc, optName) {
      fs.classList.add('selma-select-option');
      var radios = [].slice.call(fs.querySelectorAll('input[type="radio"]'));
      if (!radios.length) return;
      radios.forEach(function (r) {
        r.classList.add('selma-sr-only');
        var l = fs.querySelector('label[for="' + CSS.escape(r.id) + '"]');
        if (l) l.classList.add('selma-hidden');
      });
      var sel = document.createElement('select');
      sel.className = 'selma-select';
      sel.setAttribute('aria-label', optName);
      var ph = document.createElement('option');
      ph.value = '';
      ph.textContent = 'Select an option';
      ph.disabled = true;
      sel.appendChild(ph);
      radios.forEach(function (r) {
        var o = document.createElement('option');
        o.value = r.value;
        o.textContent = r.value;
        sel.appendChild(o);
      });
      if (lastPicked[optName]) {
        sel.value = lastPicked[optName];
      } else {
        ph.selected = true;
      }
      sel.addEventListener('change', function () {
        var r = radios.filter(function (x) { return x.value === sel.value; })[0];
        if (!r) return;
        lastPicked[optName] = sel.value;
        sel.classList.remove('selma-select--error');
        r.checked = true;
        r.dispatchEvent(new Event('change', { bubbles: true }));
      });
      fs.appendChild(sel);
      fetchProductJson(function (d) {
        var optIndex = -1;
        (d.options || []).forEach(function (o, i) {
          var nm = (o && o.name) ? o.name : o;
          if (String(nm).toLowerCase() === optName.toLowerCase()) optIndex = i;
        });
        if (optIndex === -1) return;
        var tpl = displayedMoneyTemplate();
        var rows = [];
        [].slice.call(sel.options).forEach(function (o) {
          if (!o.value) return;
          var v = null;
          d.variants.forEach(function (x) {
            if (!v && x.options[optIndex] === o.value) v = x;
          });
          if (v) rows.push({ o: o, v: v });
        });
        // Only show a price per row when the rows actually differ in price
        // (e.g. birthstones all cost the same, so their names stay plain).
        var distinct = {};
        rows.forEach(function (r) { distinct[r.v.price] = true; });
        if (Object.keys(distinct).length < 2) return;
        rows.forEach(function (r) {
          var f = tpl ? formatCentsLikeDisplayed(r.v.price, tpl) : null;
          if (f) r.o.textContent = r.o.value + ' (' + f + ')';
        });
      });
      wireSelectValidation();
    }

    // Format a cent amount the same way the page's own price is formatted
    // (works in every market currency; /products/*.js returns presentment cents).
    function displayedMoneyTemplate() {
      var scope = document.querySelector('.product__info-container') || document;
      var el = scope.querySelector('.price__sale .price-item--sale') || scope.querySelector('.price__regular .price-item--regular');
      return el ? el.textContent.trim() : '';
    }

    function formatCentsLikeDisplayed(cents, tpl) {
      var m = tpl.match(/(\d[\d.,\s\u00a0']*\d|\d)/);
      if (!m) return null;
      var numStr = m[1];
      var dec = null;
      if (/[.,]\d{2}$/.test(numStr)) dec = numStr.charAt(numStr.length - 3);
      var thou = null;
      var intPart = dec ? numStr.slice(0, -3) : numStr;
      var tm = intPart.match(/[.,\s\u00a0']/);
      if (tm) thou = tm[0];
      var units = Math.floor(cents / 100);
      var rem = ('0' + (cents % 100)).slice(-2);
      var intStr = String(units);
      if (thou) intStr = intStr.replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      var out = intStr + (dec ? dec + rem : '');
      return tpl.replace(m[1], out);
    }

    function wireSelectValidation() {
      if (wireSelectValidation.done) return;
      wireSelectValidation.done = true;
      form.addEventListener('submit', function (e) {
        var bad = null;
        [].slice.call(document.querySelectorAll('.selma-select')).forEach(function (s2) {
          if (!s2.value) { s2.classList.add('selma-select--error'); if (!bad) bad = s2; }
        });
        if (bad) {
          e.preventDefault();
          e.stopImmediatePropagation();
          bad.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, true);
    }

    // ---------- drawer ----------
    var drawerEl = null;
    function openDrawer(title, items, onPick) {
      closeDrawer();
      var overlay = document.createElement('div');
      overlay.className = 'selma-drawer-overlay';
      var panel = document.createElement('div');
      panel.className = 'selma-drawer';
      panel.innerHTML = '<div class="selma-drawer-head"><span class="selma-drawer-title">' + title + '</span>' +
        '<button type="button" class="selma-drawer-close" aria-label="Close">&times;</button></div>' +
        '<div class="selma-drawer-grid"></div>';
      var grid = panel.querySelector('.selma-drawer-grid');
      items.forEach(function (it, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'selma-drawer-option';
        b.innerHTML = (it.img ? '<span class="selma-drawer-imgwrap"><img src="' + imgUrl(it.img, 120) + '" alt="' + it.label + '" width="53" height="53" loading="lazy"></span>' : '') +
          '<span class="selma-drawer-label">' + it.label + '</span>';
        b.addEventListener('click', function () { onPick(i); closeDrawer(); });
        grid.appendChild(b);
      });
      overlay.addEventListener('click', closeDrawer);
      panel.querySelector('.selma-drawer-close').addEventListener('click', closeDrawer);
      document.body.appendChild(overlay);
      document.body.appendChild(panel);
      requestAnimationFrame(function () { overlay.classList.add('is-open'); panel.classList.add('is-open'); });
      drawerEl = { overlay: overlay, panel: panel };
      document.addEventListener('keydown', escClose);
    }
    function escClose(e) { if (e.key === 'Escape') closeDrawer(); }
    function closeDrawer() {
      if (!drawerEl) return;
      drawerEl.overlay.remove(); drawerEl.panel.remove(); drawerEl = null;
      document.removeEventListener('keydown', escClose);
    }

    // ---------- personalisation field builders ----------
    function buildField(f, idx, form) {
      var wrap = document.createElement('div');
      wrap.className = 'selma-field';
      wrap.dataset.selmaField = f.name;
      var labelText = f.label || prettyName(f.name);
      if (f.k === 'text') {
        var id = 'selma-field-' + idx;
        wrap.innerHTML = '<label class="selma-field-label" for="' + id + '">' + labelText.replace(/\*$/, '') +
          (f.req ? '<span class="selma-req">*</span>' : '') + '</label>';
        var input = document.createElement('input');
        input.type = 'text';
        input.id = id;
        input.className = 'selma-input';
        input.name = f.name;
        if (f.max) input.maxLength = f.max;
        if (f.ph) input.placeholder = f.ph;
        if (f.pattern) input.pattern = f.pattern;
        if (f.req) input.dataset.selmaRequired = 'true';
        input.setAttribute('form', form.getAttribute('id'));
        wrap.appendChild(input);
      } else if (f.k === 'letters') {
        wrap.innerHTML = '<div class="selma-field-label">' + labelText.replace(/\*$/, '') + '<span class="selma-req">*</span></div>';
        var grid = document.createElement('div');
        grid.className = 'selma-letter-grid';
        var letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
        if (f.heart) letters.unshift('❤');
        var hidden = hiddenInput(f.name, form);
        letters.forEach(function (ch) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'selma-letter';
          b.textContent = ch;
          b.addEventListener('click', function () {
            grid.querySelectorAll('.selma-letter').forEach(function (x) { x.classList.remove('is-selected'); });
            b.classList.add('is-selected');
            hidden.value = ch;
          });
          grid.appendChild(b);
        });
        hidden.dataset.selmaRequired = 'true';
        wrap.appendChild(grid);
        wrap.appendChild(hidden);
      } else if (f.k === 'drawer') {
        wrap.innerHTML = '<div class="selma-field-label">' + labelText.replace(/\*$/, '') + '<span class="selma-req">*</span></div>';
        var dopts = f.options || [];
        var hidden3 = hiddenInput(f.name, form);
        hidden3.dataset.selmaRequired = 'true';
        var pill3 = makePill(f.pill || 'Select');
        pill3.btn.addEventListener('click', function () {
          openDrawer(f.title || 'Select', dopts.map(function (o) { return { label: o.v, img: o.img || null }; }), function (i) {
            hidden3.value = dopts[i].v;
            setPill(pill3, dopts[i].v, dopts[i].img || null);
          });
        });
        wrap.appendChild(pill3.wrap);
        wrap.appendChild(hidden3);
      } else if (f.k === 'stones') {
        wrap.innerHTML = '<div class="selma-field-label">' + labelText.replace(/\*$/, '') + '<span class="selma-req">*</span></div>';
        var set = CFG.sets[f.set] || [];
        var hidden2 = hiddenInput(f.name, form);
        hidden2.dataset.selmaRequired = 'true';
        var pill = makePill('Add a birthstone');
        pill.btn.addEventListener('click', function () {
          openDrawer('Select Birthstone', CFG.stones.map(function (s, i) { return { label: s, img: set[i] }; }), function (i) {
            hidden2.value = CFG.stones[i];
            setPill(pill, CFG.stones[i], set[i]);
          });
        });
        wrap.appendChild(pill.wrap);
        wrap.appendChild(hidden2);
      }
      return wrap;
    }

    function hiddenInput(name, form) {
      var h = document.createElement('input');
      h.type = 'hidden';
      h.name = name;
      h.setAttribute('form', form.getAttribute('id'));
      return h;
    }

    function prettyName(name) {
      var m = name.match(/properties\[(.+)\]/);
      var raw = m ? m[1] : name;
      return raw.replace(/_/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); }) + ':';
    }

    // ---------- count-driven visibility ----------
    function wireCounts(conf, host) {
      var countName = Object.keys(conf.o).filter(function (k) { return conf.o[k].ui === 'count'; })[0];
      var fields = [].slice.call(host.querySelectorAll('.selma-field'));
      var numbered = fields.filter(function (w) { return /(\d)(st|nd|rd|th)|_(\d+)(_|\])|\[(\d)/.test(w.dataset.selmaField); });
      if (!countName || numbered.length < 2) return;
      function applyCount() {
        var checked = document.querySelector('variant-selects input[type="radio"]:checked, variant-radios input[type="radio"]:checked, .product-form__input select');
        var n = numbered.length;
        // find the checked value of the count option specifically
        var fsets = document.querySelectorAll('variant-selects fieldset, variant-radios fieldset');
        fsets.forEach(function (fs) {
          var lg = fs.querySelector('legend, .form__label');
          if (lg && lg.textContent.toLowerCase().indexOf(countName.toLowerCase()) !== -1) {
            var c = fs.querySelector('input[type="radio"]:checked');
            if (c) { var num = parseInt((c.value.match(/\d+/) || ['1'])[0], 10); if (num) n = num; }
          }
        });
        numbered.forEach(function (w, i) {
          var on = i < n;
          w.classList.toggle('selma-hidden', !on);
          w.querySelectorAll('input').forEach(function (inp) {
            if (on) { inp.dataset.selmaRequired = 'true'; }
            else { delete inp.dataset.selmaRequired; inp.value = ''; }
            if (inp.type === 'hidden' || inp.type === 'text') inp.disabled = !on;
          });
        });
      }
      document.addEventListener('change', function (e) { if (e.target.matches('input[type="radio"], select')) setTimeout(applyCount, 50); });
      applyCount();
    }

    // ---------- validation ----------
    function validate(host) {
      var ok = true;
      host.querySelectorAll('input[data-selma-required]').forEach(function (inp) {
        if (inp.disabled) return;
        var wrap = inp.closest('.selma-field');
        var empty = !inp.value || !inp.value.trim();
        if (wrap) wrap.classList.toggle('selma-field--error', empty);
        if (empty) ok = false;
      });
      if (!ok) {
        var first = host.querySelector('.selma-field--error');
        if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return ok;
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
